/** Search-filter categories — not the organiser's free-text activity. */
const SEARCH_EVENT_CATEGORIES = new Set([
  'wellness',
  'arts',
  'community',
  'celebrations'
]);

export const parseBookingRequirements = (booking) => {
  const raw = booking?.requirements;
  if (!raw) return {};
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }
  return {};
};

/**
 * User-facing event activity from a booking record.
 * Prefers free-text activity/event_name over search category slugs in event_type.
 */
export const resolveBookingActivity = (booking) => {
  if (!booking) return '';

  const req = parseBookingRequirements(booking);
  const activity = String(
    booking.activity ??
      req.activity ??
      booking.event_name ??
      req.event_name ??
      ''
  ).trim();

  if (activity) return activity;

  const eventType = String(booking.event_type ?? booking.eventType ?? '').trim();
  if (eventType && !SEARCH_EVENT_CATEGORIES.has(eventType.toLowerCase())) {
    return eventType;
  }

  return '';
};

const parseContactNameFromEventName = (eventName) => {
  const raw = String(eventName || '').trim();
  if (!raw || !raw.includes(' - ')) return '';
  return raw.split(' - ')[0].trim();
};

/**
 * Resolve organiser / customer contact for display and emails.
 * Mirrors backend organizer_contact_from_booking plus booking-notes and event_name fallbacks.
 */
export const resolveBookingOrganizerContact = (booking, noteFallback = null) => {
  if (!booking) {
    return { name: null, email: null, phone: null };
  }

  const req = parseBookingRequirements(booking);
  const ci = req.customer_info && typeof req.customer_info === 'object' ? req.customer_info : {};

  let name = String(
    ci.name || booking.contact_name || booking.organizer_name || booking.customer_name || ''
  ).trim();
  let email = String(
    ci.email || booking.contact_email || booking.organizer_email || booking.customer_email || ''
  ).trim();
  let phone = String(
    ci.phone || booking.contact_phone || booking.customer_phone || booking.phone || ''
  ).trim();

  if (noteFallback) {
    name = name || String(noteFallback.created_by_name || noteFallback.createdByName || '').trim();
    email = email || String(noteFallback.created_by_email || noteFallback.createdByEmail || '').trim();
  }

  if (!name) {
    name = parseContactNameFromEventName(booking.event_name || booking.event || booking.eventName);
  }

  return {
    name: name || null,
    email: email || null,
    phone: phone || null
  };
};
